import { addShopcartItem } from '@common/Checkout/Shopcart/services';

const hooks = () => {
    /**
     * Used only for synthetic tests
     * Hook to add item to cart.
     *
     * @param {integer} eanId
     */
    App.Component.addShopcartItem = async (eanId) => {
        try {
            await addShopcartItem(eanId);
        } catch (e) {

        }
    };
};

export default hooks;
